import React from "react";

function StockDailyNewsInlineEditField({
  value,
  onChange,
  disabled = false,
  maxLength = 500,
  onSave,
  onCancel,
}) {
  return (
    <textarea
      className="input stock-daily-news-inline-edit"
      value={value}
      onChange={onChange}
      disabled={disabled}
      maxLength={maxLength}
      rows={2}
      autoFocus
      onKeyDown={(e) => {
        if (e.key === "Escape") {
          e.preventDefault();
          onCancel();
          return;
        }
        if (e.key === "Enter" && !e.shiftKey) {
          e.preventDefault();
          onSave();
        }
      }}
    />
  );
}

export default StockDailyNewsInlineEditField;
